import axios from 'axios';


const _URL_API = process.env.REACT_APP_API_URL
const _URL = process.env.REACT_APP_URL

const URL_API = _URL_API || 'https://api.ihore.id/api'
const URL = _URL || 'https://api.ihore.id'


const config = {
    baseApi: process.env.NODE_ENV === 'development' ? 'http://192.168.180.101:3333/api' : URL_API,
    baseUrl: process.env.NODE_ENV === 'development' ? URL : URL,
    // 'https://api-primary.tunasmultidata.id',
}

if (typeof window !== 'undefined') {
    const host = window.location.host  // contoh: libre-nms.ihore.id:8090
    if (host === 'libre-nms.ihore.id:8090') {
        config.baseApi = 'http://192.168.180.101:3000/api'
    }
}


let target_url = config.baseApi

if (window.location.host === "billing-pkl.sks.net.id") {
    target_url = `https://billing-pkl.sks.net.id/local/api`
}
/* agar cors hilang */
if (window.location.host === "billing.ihore.id") {
    target_url = `https://billing.ihore.id/v2/api`
}
// console.log(config.baseApi)


const GetToken = () => {
    let tmp = null
    if (typeof localStorage !== 'undefined') {
        tmp = localStorage && localStorage.getItem('authToken')
    } else if (typeof sessionStorage !== 'undefined') {
        tmp = sessionStorage.getItem('authToken');
    } else {
        // If neither localStorage nor sessionStorage is supported
        console.log('Web Storage is not supported in this environment.');
    }


    try {
        // console.log(tmp)
        tmp = tmp && JSON.parse(tmp)
        return tmp
    } catch (error) {
        return null
    }
}


const _url = `${target_url}`


const api = axios.create({
    baseURL: _url,
    timeout: 30000, // 30 seconds
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor untuk menambahkan token
api.interceptors.request.use(
    (config) => {
        const token = GetToken()
        if (token?.token) {
            config.headers.Authorization = `Bearer ${token?.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor untuk error handling
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Handle token expired (401)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Try to refresh token
                const refreshToken = localStorage.getItem('refresh_token');
                if (refreshToken) {
                    const response = await axios.post('/api/auth/refresh', {
                        refresh_token: refreshToken
                    });

                    const { token } = response.data;
                    localStorage.setItem('auth_token', token);

                    // Retry original request
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return api(originalRequest);
                }
            } catch (refreshError) {
                // Refresh failed, logout user
                localStorage.removeItem('auth_token');
                localStorage.removeItem('refresh_token');
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        // Handle network errors
        if (!error.response) {
            console.error('Network error:', error.message);
            return Promise.reject({
                message: 'Network error. Please check your connection.',
                isNetworkError: true
            });
        }

        // Handle server errors
        if (error.response.status >= 500) {
            console.error('Server error:', error.response);
            return Promise.reject({
                message: 'Server error. Please try again later.',
                status: error.response.status
            });
        }

        return Promise.reject(error);
    }
);

// Helper untuk retry requests
api.retry = async (requestFn, maxRetries = 3, delay = 1000) => {
    let lastError;

    for (let i = 0; i < maxRetries; i++) {
        try {
            return await requestFn();
        } catch (error) {
            lastError = error;

            // Don't retry on 4xx errors (except 429 - too many requests)
            if (error.response?.status < 500 && error.response?.status !== 429) {
                throw error;
            }

            // Exponential backoff
            await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
        }
    }

    throw lastError;
};

export default api;